
import { mapGetters, mapMutations, mapState } from 'vuex';
import LoaderDots from '~/components/elements/LoaderDots';
import OrderListItemWrapper from '~/components/catalog/orderList/Item/Wrapper';
import OrderListDeliveriesItem from '~/components/catalog/orderList/Deliveries/Item';
import env from '~/.env.json';

export default {
  name: 'OrderListDeliveries',
  components: {
    OrderListItemWrapper,
    OrderListDeliveriesItem,
    LoaderDots,
  },
  props: {
    deliveries: {
      type: Array,
      required: true,
    },
    loadingDelivery: {
      type: Boolean,
      default: false,
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      infoPickupDisabled: env.DELIVERY_PICKUP_DISABLED || false,
      hasListDeliveries: env.DELIVERY_PRODUCT_CARD_LOAD || false,
    };
  },
  computed: {
    ...mapState('geolocation', ['selectedCity']),
    ...mapGetters({
      getSelectedCity: 'geolocation/getSelectedCity',
      getSelectedCityType: 'geolocation/getSelectedCityType',
    }),
  },
  methods: {
    ...mapMutations('geolocation', {
      setVisibleLocationModal: 'SET_VISIBLE_LOCATION_MODAL',
    }),
    openLocationModal() {
      this.setVisibleLocationModal(true);
    },
  },
};
